import { ViewChild, TemplateRef, ViewChildren, QueryList } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
} from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { KpimasterService } from 'src/app/services/kpimaster.service';
import { ToastrService } from 'ngx-toastr';
import { UserManagementService } from 'src/app/services/usermanagement.service';
import { Router } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { TranslaterService } from 'src/app/services/translater.service';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Multilingual } from 'src/app/services/multilingual';
import { WhatAppConfigService } from 'src/app/services/what-app-config.service';
import { NgxSpinnerService } from 'ngx-spinner';
import * as moment from 'moment';
import { ButtonEditRendererComponent } from 'src/app/components/button-edit-render.components';
import { ButtonDeleteRendererComponent } from 'src/app/components/button-delete-render.components';
import { ButtonViewRendererComponent } from 'src/app/components/button-view-render.components';
interface Group {
  value: string;
  viewValue: string;
}
@Component({
  selector: 'app-what-app-config',
  templateUrl: './what-app-config.component.html',
  styleUrls: ['./what-app-config.component.scss']
})
export class WhatAppConfigComponent implements OnInit {
  languageDir = 'ltr';
  langObj: any = {};
  moduleId!: any;
  pageId!: any;
  lang: any;
  frameworkComponents: any;
  constructor(
    private kpiMaster: KpimasterService,
    private toaster: ToastrService,
    private fb: FormBuilder,
    private usermanagementService: UserManagementService,
    private whatAppConfigService: WhatAppConfigService,
    public router: Router,
    private dialog: MatDialog,
    public translater: TranslaterService,
    public translate: TranslateService,
    private spinner: NgxSpinnerService,
  ) {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {

      if (event.lang === 'ar') {
        this.languageDir = 'rtl';
        this.getLangWords();
      } else if (event.lang === 'en') {
        this.languageDir = 'ltr';
        this.getLangWords();
      } else if (event.lang === 'fr') {
        this.languageDir = 'ltr';
        this.getLangWords();
      } else if (event.lang === 'sp') {
        this.languageDir = 'ltr';
        this.getLangWords();
      }
    });
    this.frameworkComponents = {
      buttonRenderer: ButtonEditRendererComponent,
      buttonRendererDelete: ButtonDeleteRendererComponent,
      buttonRendererView: ButtonViewRendererComponent
    };
  }

  whatAppConfigList!: any[];
  whatAppInfoDataSource!: MatTableDataSource<any>;
  whatAppInfoColumns: any[] = [
    'ToNumber',
    'MsgContent',
    'IsProcessed',
    'ResponseSid',
    'StatusMsg',
    'ProcessedOn',
    'CreatedOn',
    'CreatedBy',
  ];
  @ViewChild('displayRoleModal') private displayRoleModal!: TemplateRef<any>;
  @ViewChild('displayChildModal')
  private displayChildModal!: TemplateRef<any>;
  @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();
  @ViewChildren(MatSort) sort = new QueryList<MatSort>();
  IsAccess: any;
  filteredModules!: any[];
  filteredUsers!: any[];
  IsWrite: any;
  breadcrumList: any;
  errorMessage!: any;
  whatAppConfigForm!: FormGroup;
  addWhatAppConfigForm!: FormGroup;
  whatAppConfigMode = true;
  Group!: string;
  columnDefs!: any[];
  groupList!: any[];
  plantsList!: any[];
  Plants!: any[];
  filteredModule!: any[];
  whatAppConfigId!: any;
  IsActive = true;
  user: any;
  gridApi: any;
  gridColumnApi: any;
  Date = new Date();

  gridOptions: any = {
    CodefaultlDef: {
      rowModelType: 'infinite',
      infiniteInitialRowCount: 2,
      flex: 1,
      sortable: true,
      resizable: true,
      wrapText: true, // <-- HERE
      autoHeight: true, // <-- & HERE
      minWidth: 225,
    },
    medalColumn: {
      width: 100,
      columnGroupShow: 'open',
      filter: false,
    },
    popupParent: document.querySelector('body'),
    floatingFilter: true,
  };

  ngOnInit(): void {
    this.user = localStorage.getItem('user');
    this.user = JSON.parse(this.user);
    this.whatAppConfigForm = this.fb.group({
      group: [''],
      plant: [''],
    });

    this.addWhatAppConfigForm = this.fb.group({
      accountSid: [''],
      user: [''],
      userType: [''],
      remarks: [''],
      authToken: [''],
      fromNumber: [''],
      isActive: [''],
    });
    this.GetBreadcrumList();
    this.GetMenuAccess();
    this.getGroups();
  }

  // breadCrumb
  GetMenuAccess(): void {
    const key = {
      Id: localStorage.getItem('O3RightMenuId'),
    };
    this.kpiMaster.GetMenuAccess(key).subscribe(
      (data: any) => {
        this.IsAccess = data.IsAccess;
        this.IsWrite = data.IsWrite;
        this.columnDefs = [
          {
            headerName: 'Actions',
            field: 'Actions',
            cellRenderer: 'buttonRenderer',
            cellRendererParams: {
              onClick: this.editWhatAppConfig.bind(this),
              label: 'Edit',
            },
            maxWidth: 75,
            minWidth: 50,
            cellStyle: { textAlign: 'left' },
            hide: !this.IsWrite,
            suppressMenu: true,
            headerValueGetter: this.localizeHeader.bind(this)
          },
          {
            headerName: ' ',
            field: 'Actions',
            cellRenderer: 'buttonRendererView',
            cellRendererParams: {
              onClick: this.openWhatAppInfoModal.bind(this),
              label: 'view',
            },
            maxWidth: 50,
            minWidth: 50,
            cellStyle: { textAlign: 'center', padding: 0 },
            hide: !this.IsWrite,
            suppressMenu: true,
          },
          {
            headerName: ' ',
            field: 'Actions',
            cellRenderer: 'buttonRendererDelete',
            cellRendererParams: {
              onClick: this.DeleteWhatAppConfig.bind(this),
              label: 'delete',
            },
            maxWidth: 50,
            minWidth: 50,
            cellStyle: { textAlign: 'center', padding: 0 },
            hide: !this.IsWrite,
            suppressMenu: true,
          },
          { headerName: 'WhatAppConfigId', field: 'whatAppConfigId', filter: 'agTextColumnFilter', headerValueGetter: this.localizeHeader.bind(this) },
          {
            headerName: 'Group',
            field: 'EG_Desc',
            filter: 'agTextColumnFilter',
            headerValueGetter: this.localizeHeader.bind(this)
          },
          {
            headerName: 'Plant',
            field: 'PT_Desc',
            filter: 'agTextColumnFilter',
            headerValueGetter: this.localizeHeader.bind(this)
          },
          {
            headerName: 'AccountSid',
            field: 'accountSid',
            filter: 'agTextColumnFilter',
            headerValueGetter: this.localizeHeader.bind(this)
          },
          {
            headerName: 'AuthToken',
            field: 'authToken',
            filter: 'agTextColumnFilter',
            headerValueGetter: this.localizeHeader.bind(this)
          },
          {
            headerName: 'FromNumber',
            field: 'fromNumber',
            filter: 'agTextColumnFilter',
            headerValueGetter: this.localizeHeader.bind(this)
          },
          {
            headerName: 'IsActive',
            field: 'isActive',
            filter: 'agTextColumnFilter',
            headerValueGetter: this.localizeHeader.bind(this)
          },
          {
            headerName: 'Created By',
            field: 'createdBy',
            filter: 'agTextColumnFilter',
            headerValueGetter: this.localizeHeader.bind(this)
          },
          {
            headerName: 'Created On',
            field: 'createdOn',
            filter: 'agDateColumnFilter',
            valueFormatter: function (params: any) {
              return moment(params.value).format('DD/MM/YYYY HH:mm');
            },
            headerValueGetter: this.localizeHeader.bind(this)
          },

        ];
      },
      (error) => {
        this.toaster.error('Error', error.error.message);
      }
    );
  }
  public localizeHeader(parameters: any) {
    let headerIdentifier = parameters.colDef.headerName;
    return this.getTransalatedValue(headerIdentifier);
  }
  getTransalatedValue(value: string) {
    let val;
    if (this.langObj && this.langObj[value]) {
      val = this.langObj[value];
    }
    return val ? val : value;
  }

  public getLangWords() {
    const key = {
      ModuleId: this.moduleId,
      PageId: this.pageId,
      LanguageId: this.translate.currentLang === 'en' ? 1 : this.translate.currentLang === 'ar' ? 2 : this.translate.currentLang === 'fr' ? 3 : this.translate.currentLang === 'sp' ? 4 : 1
    };
    this.translater.getLangWords(key).subscribe((res: any) => {
      let obj: any = {};
      res.tagList.map((elem: any) => {
        obj[elem.tagName] = elem.translatedValue;
      });
      this.langObj = obj;
      if (this.langObj) {
        this.gridApi.refreshHeader();
      }
    });
  }

  GetBreadcrumList(): any {
    const obj = {
      MenuId:
        localStorage.getItem('O3RightMenuId') === null
          ? 1
          : localStorage.getItem('O3RightMenuId'),
    };
    this.usermanagementService.GetBreadcrumList(obj).subscribe(
      (data: any) => {
        this.breadcrumList = data.BreadcrumList;
        this.moduleId = this.breadcrumList[0].id;
        this.pageId = this.breadcrumList[this.breadcrumList.length - 1].id;
        console.log(data.BreadcrumList);
        this.getLangWords();
        this.lang = new Multilingual(this.translater,this.translate);
        this.lang.getLangWords();
      },
      (error) => {
        this.toaster.error('Error', error.ErrorMessage);
      }
    );
  }
  DisplayRightmenu(menuId: any, url: any): any {
    localStorage.setItem('O3RightMenuId', menuId);
    this.router
      .navigateByUrl('/', { skipLocationChange: true })
      .then(() => this.router.navigate([url]));
  }

  openModal(): void {
    this.whatAppConfigMode = true;
    this.addWhatAppConfigForm.get('accountSid')?.reset();
    this.addWhatAppConfigForm.get('authToken')?.reset();
    this.addWhatAppConfigForm.get('fromNumber')?.reset();
    this.addWhatAppConfigForm.get('isActive')?.setValue(true);
    this.dialog.open(this.displayRoleModal, { height: 'auto', width: '90%' });

  }
  openWhatAppInfoModal(element: any) {
    this.GetWhatAppConfigInfoList(element);
    this.dialog.open(this.displayChildModal, { height: 'auto', width: '90%' });
  }
  openModalForEditWhatAppConfig(): void {
    this.whatAppConfigMode = true;
    this.addWhatAppConfigForm.get('accountSid')?.reset();
    this.addWhatAppConfigForm.get('plant')?.reset();
    this.addWhatAppConfigForm.get('group')?.reset();
    this.addWhatAppConfigForm.get('authToken')?.reset();
    this.addWhatAppConfigForm.get('fromNumber')?.reset();
    this.dialog.open(this.displayRoleModal, { height: 'auto', width: '90%' });
  }

  getGroups(): void {
    const key = {
      CreatedBy: 0,
    };
    this.whatAppConfigService.getGroups(key).subscribe((res: any) => {
      this.groupList = res.masterList;
      this.whatAppConfigForm.get('group')?.setValue(this.groupList[0].TypeId);
      if (this.groupList.length > 0) {
        this.filteredModules = this.groupList.slice();
      }
      this.getPlants();
    });
  }

  GetWhatAppConfigList(): void {
    this.spinner.show();
    const key = {
      groupId: this.whatAppConfigForm.value.group,
      plantId: this.whatAppConfigForm.value.plant,
    };
    this.whatAppConfigService.GetWhatAppConfigList(key).then((res: any) => {
      this.spinner.hide();
      this.whatAppConfigList = res.whatAppConfigList;
    });
  }

  GetWhatAppConfigInfoList(element: any): void {
    const key = {
      WhatAppConfigId: element.data.whatAppConfigId,
    };
    this.whatAppConfigService.GetWhatAppConfigInfoList(key).then((res: any) => {
      this.whatAppInfoDataSource = new MatTableDataSource<any>(
        res.whatAppInfoList
      );
      this.getPaginator(this.whatAppInfoDataSource, 0);
    });
  }

  SubmitWhatAppConfig(): void {
    const key = {
      WhatAppConfigId: 0,
      GroupId: this.whatAppConfigForm.value.group,
      PlantId: this.whatAppConfigForm.value.plant,
      AccountSid: this.addWhatAppConfigForm.value.accountSid,
      AuthToken: this.addWhatAppConfigForm.value.authToken,
      FromNumber: this.addWhatAppConfigForm.value.fromNumber,
      IsActive: this.addWhatAppConfigForm.value.isActive,
      CreatedBy: this.user.UserId,
      CreatedOn: new Date(),
    };
    this.whatAppConfigService.CreateWhatAppConfig(key).subscribe((res: any) => {
      this.showPopupMsg(res.ErrorMessage);
      this.GetWhatAppConfigList();
      this.whatAppConfigId = res.Id;
      this.dialog.closeAll();
    });
  }

  editWhatAppConfig(element: any): void {
    this.openModalForEditWhatAppConfig();
    this.whatAppConfigId = element.data.whatAppConfigId;
    this.whatAppConfigMode = false;
    this.addWhatAppConfigForm.get('authToken')?.setValue(element.data.authToken);
    this.addWhatAppConfigForm.get('fromNumber')?.setValue(element.data.fromNumber);
    this.addWhatAppConfigForm.get('accountSid')?.setValue(element.data.accountSid);
    this.whatAppConfigForm.get('group')?.setValue(element.data.groupId);
    this.whatAppConfigForm.get('plant')?.setValue(element.data.plantId);
    this.addWhatAppConfigForm.get('isActive')?.setValue(element.data.isActive);
  }

  UpdateWhatAppConfig(): void {
    const key = {
      GroupId: this.whatAppConfigForm.value.group,
      PlantId: this.whatAppConfigForm.value.plant,
      AccountSid: this.addWhatAppConfigForm.value.accountSid,
      AuthToken: this.addWhatAppConfigForm.value.authToken,
      FromNumber: this.addWhatAppConfigForm.value.fromNumber,
      IsActive: this.addWhatAppConfigForm.value.isActive,
      CreatedBy: this.user.UserId,
      CreatedOn: new Date(),
      WhatAppConfigId: this.whatAppConfigId,
    };
    this.whatAppConfigService.UpdateWhatAppConfig(key).subscribe((res: any) => {
      this.showPopupMsg(res.ErrorMessage);
      this.GetWhatAppConfigList();
      this.whatAppConfigMode = true;
      this.dialog.closeAll();
    });
  }

  DeleteWhatAppConfig(element: any): void {
    const key = {
      WhatAppConfigId: element.data.whatAppConfigId,
    };
    this.whatAppConfigService.DeleteWhatAppConfig(key).subscribe((res: any) => {
      this.showPopupMsg(res.ErrorMessage);
      this.GetWhatAppConfigList();
    });
  }

  showPopupMsg(msg: any): any {
    if (msg !== null || msg !== '') {
      if (msg.substring(2, 1) === '0') {
        this.toaster.error('Error', msg.substring(3, msg.length));
      } else {
        this.toaster.success('Success', msg.substring(3, msg.length));
      }
    }
  }

  getPaginator(data: MatTableDataSource<any>, index: number): void {
    setTimeout(() => {
      data.paginator = this.paginator.toArray()[index];
      data.sort = this.sort.toArray()[index];
    }, 1000);
  }
  getPlants(): void {
    const key = {
      GroupId: this.whatAppConfigForm.value.group,
    };
    this.whatAppConfigService.getPlantData(key).subscribe((res: any) => {
      this.Plants = res.DepartList;
      if (this.Plants.length > 0) {
        this.filteredModule = this.Plants.slice();
      }
      this.whatAppConfigForm.get('plant')?.setValue(this.Plants[0].DeptId);
      this.GetWhatAppConfigList();
    });
  }
  onGridReady(params: any): any {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }
}
